import { MoreVerticalIcon } from './MoreVerticalIcon';

export default MoreVerticalIcon;